export const Catalogos = {
    Estatus: {
        Activo: 2,
        Inactivo: 3,
        Eliminado: 4,
    }/*,
    Perfiles: {
        Administrador: 1,
        Empleado: 2,
        Proveedor: 3,
        Consultor: 4
    }*/
};

